import { useState, useEffect } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import { config, encodeBase64RequestBody, numberFormat, priceFormat } from "./Components/Config";
import { format } from "date-fns";

const QuotationBilling = () => {
  const { id_quotation } = useParams();
  const [ quotation, setQuotation ] = useState(null);
  const [ quotationItems, setQuotationItems ] = useState([]);
  const [ subcompanyList, setSubcompanyList ] = useState(null);
  
  const navigate = useNavigate();

  const getQuotation = async () => {
    try {
      const fetchGetQuotation = await jwtFetch(config.ENDPOINT + 'get/quotation', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_quotation: id_quotation
        })
      });
      const responseGetQuotation = await fetchGetQuotation.json();
      if (responseGetQuotation.data) {
        setQuotation(responseGetQuotation.data[0]);
        let items = [];
        for (let i in responseGetQuotation.data[0].quotation_item_list) {
          responseGetQuotation.data[0].quotation_item_list[i].companies = [{
            company_id: responseGetQuotation.data[0].subcompany_id ? responseGetQuotation.data[0].subcompany_id : '',
            company_name: responseGetQuotation.data[0].subcompany_id ? responseGetQuotation.data[0].subcompany_name : '',
            product_qty: responseGetQuotation.data[0].quotation_item_list[i].product_qty,
            product_cost_original: responseGetQuotation.data[0].quotation_item_list[i].product_cost_original,
            product_cost: responseGetQuotation.data[0].quotation_item_list[i].product_cost,
            product_price_original: responseGetQuotation.data[0].quotation_item_list[i].product_price_original,
            product_price: responseGetQuotation.data[0].quotation_item_list[i].product_price,
            product_subtotal: responseGetQuotation.data[0].quotation_item_list[i].product_subtotal,
            product_discount_price: responseGetQuotation.data[0].quotation_item_list[i].product_discount_price,
            product_discount_rate: responseGetQuotation.data[0].quotation_item_list[i].product_discount_rate,
            product_discount_prorate: responseGetQuotation.data[0].quotation_item_list[i].product_discount_prorate,
            product_margin_price: responseGetQuotation.data[0].quotation_item_list[i].product_margin_price,
            product_margin_rate: responseGetQuotation.data[0].quotation_item_list[i].product_margin_rate,
            product_total: responseGetQuotation.data[0].quotation_item_list[i].product_total,
            product_grand_total: responseGetQuotation.data[0].quotation_item_list[i].product_grand_total,
            product_prorate: 100,
            contract_long_period: responseGetQuotation.data[0].quotation_item_list[i].contract_long_period,
          }];
          items.push(responseGetQuotation.data[0].quotation_item_list[i]);
          setQuotationItems([...items]);
        }
      } else {
        alert(responseGetQuotation.message);
      }
    } catch (error) {
      console.error('Error in getQuotation:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getSubcompanyList = async () => {
    try {
      const requestSubcompanyList = {
        company_id: quotation.company_id
      }
      const fetchSubcompanyList = await jwtFetch(config.ENDPOINT + 'get/subcompany', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestSubcompanyList)
      });
      const responseSubcompanyList = await fetchSubcompanyList.json();
      if (responseSubcompanyList.status === 200) {
        setSubcompanyList(responseSubcompanyList.data);
      } else {
        alert(responseSubcompanyList.message);
      }
    } catch (error) {
      console.error('Error in getSubcompanyList:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const addCompany = (itemIndex) => {
    let companies = quotationItems[itemIndex].companies;
    companies.push({
      company_id: '',
      company_name: '',
      product_qty: 0,
      product_cost_original: 0,
      product_cost: 0,
      product_price_original: 0,
      product_price: 0,
      product_subtotal: 0,
      product_discount_price: 0,
      product_discount_rate: 0,
      product_discount_prorate: 0,
      product_margin_price: 0,
      product_margin_rate: 0,
      product_total: 0,
      product_grand_total: 0,
      product_prorate: 0,
      contract_long_period: 0,
    });
    quotationItems[itemIndex].errorQty = true;
    setQuotationItems([...quotationItems]);
  }

  const removeCompany = (itemIndex, companyIndex) => {
    let companies = quotationItems[itemIndex].companies;
    companies.splice(companyIndex, 1);
    let totalCompanyQty = quotationItems[itemIndex].companies.reduce((sum, company) => sum + company.product_qty, 0);
    let itemQty = quotationItems[itemIndex].product_qty;
    let sameQty = totalCompanyQty === itemQty;
    quotationItems[itemIndex].errorQty = totalCompanyQty !== itemQty;
    let blankQty = quotationItems[itemIndex].companies.some(company => company.product_qty === 0);
    if (blankQty || !sameQty) {
      quotationItems[itemIndex].errorQty = true;
    }
    setQuotationItems([...quotationItems]);
  }

  const changeCompanyId = (itemIndex, companyIndex, companyId) => {
    let company = quotationItems[itemIndex].companies[companyIndex];
    let subcompany = subcompanyList.find(subcompany => String(subcompany.id_subcompany) === companyId);
    if (subcompany) {
      company.company_id = companyId;
      company.company_name = subcompany.company_name;
    }
    setQuotationItems([...quotationItems]);
  }

  const changeQty = (itemIndex, companyIndex, qty) => {
    let company = quotationItems[itemIndex].companies[companyIndex];
    company.contract_long_period = quotationItems[itemIndex].contract_long_period;
    company.product_qty = numberFormat(qty);
    company.product_prorate = parseFloat((company.product_qty / quotationItems[itemIndex].product_qty * 100).toFixed(3));
    company.product_cost_original = quotationItems[itemIndex].product_cost_original;
    company.product_cost = quotationItems[itemIndex].product_cost;
    company.product_price_original = quotationItems[itemIndex].product_price_original;
    company.product_price = quotationItems[itemIndex].product_price;    
    company.product_subtotal = company.product_price * company.product_qty * company.contract_long_period;
    company.product_discount_price = parseFloat((quotationItems[itemIndex].product_discount_price * company.product_prorate / 100).toFixed(3));
    company.product_discount_rate = parseFloat((company.product_discount_price / company.product_subtotal * 100).toFixed(3));
    company.product_discount_prorate = parseFloat((quotationItems[itemIndex].product_discount_prorate * company.product_prorate / 100).toFixed(3));
    company.product_total = company.product_subtotal - company.product_discount_price;
    company.product_grand_total = company.product_total - company.product_discount_prorate;
    company.product_margin_price = company.product_grand_total - (company.product_cost * company.product_qty * company.contract_long_period);
    company.product_margin_rate = parseFloat((company.product_margin_price / company.product_grand_total * 100).toFixed(3));
    
    let totalCompanyQty = quotationItems[itemIndex].companies.reduce((sum, company) => sum + parseInt(company.product_qty), 0);
    let itemQty = quotationItems[itemIndex].product_qty;
    let sameQty = totalCompanyQty === itemQty;
    quotationItems[itemIndex].errorQty = parseInt(totalCompanyQty) !== parseInt(itemQty);

    let blankQty = quotationItems[itemIndex].companies.some(company => company.product_qty === 0);
    if (blankQty || !sameQty) {
      quotationItems[itemIndex].errorQty = true;
    }

    setQuotationItems([...quotationItems]);
  }

  const submitQuotationBillingAdd = async () => {
    try {
      const hasErrors = quotationItems.some(item => item.errorQty);
      if (hasErrors) {
        alert('Total quantity not match. Please check again.');
        return;
      }
      const crmUser = JSON.parse(localStorage.getItem('crmUser'));
      const quotationItemAccounts = [];
      const soItems = [];
      const soItemList = [];
      for (let i in quotationItems) {
        for (let c in quotationItems[i].companies) {
          if (quotationItems[i].companies[c].product_qty === 0) {
            alert('Quantity must be greater than 0. Please check again.');
            return;
          }
          quotationItemAccounts.push({
            "quotation_id": id_quotation,
            "quotation_item_id": quotationItems[i].id_quotation_item,
            "company_id": quotation.company_id,
            "subcompany_id": quotationItems[i].companies[c].company_id,
            "product_id": quotationItems[i].product_id,
            "product_display_name": quotationItems[i].product_display_name,
            "product_display_description": quotationItems[i].product_display_description,
            "product_type": quotationItems[i].product_type,
            "product_domain": quotationItems[i].product_domain,
            "product_qty": quotationItems[i].companies[c].product_qty,
            "product_currency_original": quotationItems[i].product_currency_original,
            "product_currency": quotationItems[i].product_currency,
            "product_cost_original": quotationItems[i].companies[c].product_cost_original,
            "product_cost": quotationItems[i].companies[c].product_cost,
            "product_price_original": quotationItems[i].companies[c].product_price_original,
            "product_price": quotationItems[i].companies[c].product_price,
            "product_margin_rate": quotationItems[i].companies[c].product_margin_rate,
            "product_margin_price": quotationItems[i].companies[c].product_margin_price,
            "product_subtotal": quotationItems[i].companies[c].product_subtotal,
            "product_discount_rate": quotationItems[i].companies[c].product_discount_rate,
            "product_discount_price": quotationItems[i].companies[c].product_discount_price,
            "product_discount_prorate": quotationItems[i].companies[c].product_discount_prorate,
            "product_total": quotationItems[i].companies[c].product_total,
            "product_grand_total": quotationItems[i].companies[c].product_grand_total,
            "product_prorate": quotationItems[i].companies[c].product_prorate,
            "service_type": quotationItems[i].service_type,
            "contract_long_period": quotationItems[i].contract_long_period,
            "contract_duration_period": quotationItems[i].contract_duration_period,
            "billing_long_period": quotationItems[i].billing_long_period,
            "billing_duration_period": quotationItems[i].billing_duration_period,
            "billing_payment_term": quotationItems[i].billing_payment_term,
            "billing_payment_period": quotationItems[i].billing_payment_period
          });
        }
        soItems.push({
          "product_id": quotationItems[i].product_id,
          "product_display_name": quotationItems[i].product_display_name,
          "product_display_description": quotationItems[i].product_display_description,
          "product_type": quotationItems[i].product_type,
          "product_domain": quotationItems[i].product_domain,
          "product_qty": quotationItems[i].product_qty,
          "product_currency_original": quotationItems[i].product_currency_original,
          "product_currency": quotationItems[i].product_currency,
          "product_cost_original": quotationItems[i].product_cost_original,
          "product_cost": quotationItems[i].product_cost,
          "product_price_original": quotationItems[i].product_price_original,
          "product_price": quotationItems[i].product_price,
          "product_margin_rate": quotationItems[i].product_margin_rate,
          "product_margin_price": quotationItems[i].product_margin_price,
          "product_subtotal": quotationItems[i].product_subtotal,
          "product_discount_rate": quotationItems[i].product_discount_rate,
          "product_discount_price": quotationItems[i].product_discount_price,
          "product_discount_prorate": quotationItems[i].product_discount_prorate,
          "product_total": quotationItems[i].product_total,
          "product_grand_total": quotationItems[i].product_grand_total,
          "product_active_licence_date": null,
          "service_type": quotationItems[i].service_type,
          "contract_long_period": quotationItems[i].contract_long_period,
          "contract_duration_period": quotationItems[i].contract_duration_period,
          "billing_long_period": quotationItems[i].billing_long_period,
          "billing_duration_period": quotationItems[i].billing_duration_period,
          "billing_payment_term": quotationItems[i].billing_payment_term,
          "billing_payment_period": quotationItems[i].billing_payment_period,
          "status": "In Progress",
        });
        soItemList.push({
          "product_id": quotationItems[i].product_id,
          "product_display_name": quotationItems[i].product_display_name,
          "product_display_description": quotationItems[i].product_display_description,
          "product_type": quotationItems[i].product_type,
          "product_domain": quotationItems[i].product_domain,
          "product_qty": quotationItems[i].product_qty,
          "product_currency_original": quotationItems[i].product_currency_original,
          "product_currency": quotationItems[i].product_currency,
          "product_cost_original": quotationItems[i].product_cost_original,
          "product_cost": quotationItems[i].product_cost,
          "product_price_original": quotationItems[i].product_price_original,
          "product_price": quotationItems[i].product_price,
          "product_margin_rate": quotationItems[i].product_margin_rate,
          "product_margin_price": quotationItems[i].product_margin_price,
          "product_subtotal": quotationItems[i].product_subtotal,
          "product_discount_rate": quotationItems[i].product_discount_rate,
          "product_discount_price": quotationItems[i].product_discount_price,
          "product_discount_prorate": quotationItems[i].product_discount_prorate,
          "product_total": quotationItems[i].product_total,
          "product_grand_total": quotationItems[i].product_grand_total,
          "product_active_licence_date": null,
          "service_type": quotationItems[i].service_type,
          "contract_long_period": quotationItems[i].contract_long_period,
          "contract_duration_period": quotationItems[i].contract_duration_period,
          "billing_long_period": quotationItems[i].billing_long_period,
          "billing_duration_period": quotationItems[i].billing_duration_period,
          "billing_payment_term": quotationItems[i].billing_payment_term,
          "billing_payment_period": quotationItems[i].billing_payment_period,
          "status": "In Progress",
        });
      }
      const requestQuotationBillingAdd = {
        "quotation_id": id_quotation,
        "quotation_item_accounts": quotationItemAccounts,
        "action": 'Setting Billing Account',
        "updated_by": crmUser.user_keyid,
        "updated_on": format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        "so": {
          "quotation_id": id_quotation,
          "company_id": quotation.company_id,
          "subcompany_id": quotation.subcompany_id,
          "so_currency": quotation.quotation_currency,
          "so_exchange_rate": quotation.quotation_exchange_rate,
          "so_expired_date": format(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), 'yyyy-MM-dd'),
          "so_billing_date": format(new Date(), 'yyyy-MM-dd'),
          "so_subtotal": quotation.quotation_subtotal,
          "so_discount_rate": quotation.quotation_discount_rate,
          "so_discount_price": quotation.quotation_discount_price,
          "so_cost": quotation.quotation_cost,
          "so_margin_rate": quotation.quotation_margin_rate,
          "so_margin_price": quotation.quotation_margin_price,
          "so_total": quotation.quotation_total,
          "so_approval": 'Draft',
          "so_status": 'In Progress',
          "created_on": format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          "created_by": crmUser.user_keyid,
        },
        "so_item": soItems,
        "so_item_list": soItemList,
      };
      const fetchQuotationAdd = await jwtFetch(config.ENDPOINT + 'setting/billing_account', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestQuotationBillingAdd)
      });
      const responseQuotationAdd = await fetchQuotationAdd.json();
      if (responseQuotationAdd.status === 200) {
        window.location.href = '/quotation/detail/' + id_quotation;
      } else {
        alert(responseQuotationAdd.message);
      }
    } catch (error) {
      console.error('Error in submitQuotationBillingAdd:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  useEffect(() => {
    getQuotation();
  }, []);

  useEffect(() => {
    if (quotation) {
      getSubcompanyList();
    }
  }, [quotation]);

  return (
    <div id="quotation-billing">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="quotation"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="p-4">
              
              {quotation && (
                <div className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Quotation Billing Accounts</div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Number</div>
                        <div className="col-md-8">{quotation.quotation_code} <a href={`/quotation/detail/${quotation.id_quotation}`}><i className="bi bi-link-45deg"/></a></div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Company</div>
                        <div className="col-md-8">{quotation.company_name} <a href={`/client/detail/${quotation.company_id}`}><i className="bi bi-link-45deg"/></a></div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-md-4 text-secondary">Subsidiary</div>
                        <div className="col-md-8">{quotation.subcompany_name} <a href={`/client/subsidiary/detail/${quotation.subcompany_id}`}><i className="bi bi-link-45deg"/></a></div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Subtotal</div>
                        <div className="col-md-8">{priceFormat(quotation.quotation_subtotal, quotation.quotation_currency)}</div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Discount ({priceFormat(quotation.quotation_discount_rate)}%)</div>
                        <div className="col-md-8">{priceFormat(quotation.quotation_discount_price, quotation.quotation_currency)}</div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-md-4 text-secondary">Total Before Tax</div>
                        <div className="col-md-8">{priceFormat(quotation.quotation_total, quotation.quotation_currency)}</div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Total Cost</div>
                        <div className="col-md-8">{priceFormat(quotation.quotation_cost, quotation.quotation_currency)}</div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Total Margin ({priceFormat(quotation.quotation_margin_rate)}%)</div>
                        <div className="col-md-8">{priceFormat(quotation.quotation_margin_price, quotation.quotation_currency)}</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {quotation && (
                <div className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24">Item List</div>
                  </div>
                  {quotationItems && quotationItems.map((item, i) =>
                    <div className="card mb-4" key={"item-" + i}>
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="fs-18"><strong>Item #{i + 1} &emsp; {item.product_display_name}</strong> {item.bundle_name && (<span className="badge badge-secondary text-bg-secondary ms-2">{item.bundle_name}</span>)}</div>
                        </div>
                        <div className="row mb-4">
                          <div className="col-md-6">
                            <div className="row mb-2">
                              <div className="col-md-4 text-secondary">Type</div>
                              <div className="col-md-8">{item.product_type}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-4 text-secondary">Service Type</div>
                              <div className="col-md-8">{item.service_type}</div>
                            </div>
                            <div className="row">
                              <div className="col-md-4 text-secondary">Quantity</div>
                              <div className="col-md-8">{priceFormat(item.product_qty)} Unit(s)</div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row mb-2">
                              <div className="col-md-4 text-secondary">Subtotal</div>
                              <div className="col-md-8 text-end">{priceFormat(item.product_total, item.product_currency)}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-4 text-secondary">Prorated Discount</div>
                              <div className="col-md-8 text-end">{priceFormat(item.product_discount_prorate, item.product_currency)}</div>
                            </div>
                            <div className="row">
                              <div className="col-md-4 text-secondary">Total</div>
                              <div className="col-md-8 text-end">{priceFormat(item.product_grand_total, item.product_currency)}</div>
                            </div>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="bg-secondary text-light">#</th>
                                <th className="bg-secondary text-light w-400">Subsidiary</th>
                                <th className="bg-secondary text-light" style={{textAlign: 'center'}}>Qty</th>
                                <th className="bg-secondary text-light" style={{textAlign: 'center'}}>Payment Amount</th>
                                <th className="bg-secondary text-light"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.companies.map((company, c) =>
                                <tr key={"item-" + i + "-company-" + c}>
                                  <td valign="middle">{c + 1}</td>
                                  <td>
                                    <select className="form-select" value={company.company_id} onChange={(e) => changeCompanyId(i, c, e.target.value)} required>
                                      <option value=""></option>
                                      {subcompanyList && [...subcompanyList].sort((a, b) => (a.company_name || '').localeCompare(b.company_name || '')).map((subcompany, s) =>
                                        <option key={"subcompany-" + s} value={subcompany.id_subcompany}>{subcompany.company_name}</option>
                                      )}
                                    </select>
                                  </td>
                                  <td>
                                    <div className="input-group">
                                      <input className={"form-control text-end " + (item.errorQty ? 'border-danger' : '')} type="text" value={priceFormat(company.product_qty)} onChange={(e) => changeQty(i, c, e.target.value)} required/>
                                      <span className="input-group-text mw-85">Unit(s)</span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="input-group">
                                      <input className={"form-control text-end"} type="text" value={priceFormat(company.product_grand_total)} required disabled/>
                                      <span className="input-group-text mw-85">{item.product_currency}</span>
                                    </div>
                                    <div className="d-none">         
                                        <div className="d-flex justify-content-between"><span>product_prorate:</span><span>{priceFormat(company.product_prorate)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_cost_original:</span><span>{priceFormat(company.product_cost_original)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_cost:</span><span>{priceFormat(company.product_cost)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_price_original:</span><span>{priceFormat(company.product_price_original)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_price:</span><span>{priceFormat(company.product_price)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_subtotal:</span><span>{priceFormat(company.product_subtotal)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_discount_price:</span><span>{priceFormat(company.product_discount_price)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_discount_rate:</span><span>{priceFormat(company.product_discount_rate)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_discount_prorate:</span><span>{priceFormat(company.product_discount_prorate)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_total:</span><span>{priceFormat(company.product_total)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_grand_total:</span><span>{priceFormat(company.product_grand_total)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_margin_price:</span><span>{priceFormat(company.product_margin_price)}</span></div>
                                        <div className="d-flex justify-content-between"><span>product_margin_rate:</span><span>{priceFormat(company.product_margin_rate)}</span></div>
                                        <div className="d-flex justify-content-between"><span>contract_long_period:</span><span>{priceFormat(company.contract_long_period)}</span></div>
                                    </div>
                                  </td>
                                  <td>
                                    <button className="btn btn-link text-danger" type="button" onClick={() => removeCompany(i, c)} disabled={item.companies.length === 1}><i className="bi bi-trash me-2"/></button>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="flex">
                          <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => addCompany(i)}><i className="bi bi-plus-lg me-2"/> Subsidiary</button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              
              {quotation && (
                <div className="mb-4">
                  <div className="d-flex justify-content-end">
                    <button className="btn btn-primary" type="button" onClick={() => submitQuotationBillingAdd()}>Save</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationBilling;


